import { Injectable } from '@angular/core';
import { FileDescriptor } from '@models/data/file-descriptor/FileDescriptor';
import { FileStorageHttpService } from '@services/http/file-storage/file-storage-http.service';
import { firstValueFrom } from 'rxjs';
import { IFileStorageQueryParams } from '@models/data/file-storage/interfaces/IFileStorageQueryParams';
import { SpecificResourceMap } from '@models/data/file-storage/enums/SpecificResourceMap.enum';
import { SpecificDirectoryMap } from '@models/data/file-storage/enums/SpecificDirectoryMap.enum';
import { SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class FileStorageService {
  constructor(private httpService: FileStorageHttpService) {}

  public getProfilePicture(fitMedProfileId: string): SafeResourceUrl {
    return this.getFileUrl(
      fitMedProfileId,
      SpecificResourceMap.Users,
      SpecificDirectoryMap.ProfilePicture
    );
  }

  public getFileUrl(
    id: string,
    specificResourceMap: SpecificResourceMap,
    specificDirectoryMap: SpecificDirectoryMap
  ): SafeResourceUrl {
    return this.httpService.getFileUrl(
      id,
      specificResourceMap,
      specificDirectoryMap
    );
  }

  public async upload(
    file: string | Blob,
    queryParams: IFileStorageQueryParams
  ): Promise<FileDescriptor> {
    return firstValueFrom(
      await this.httpService.upload(file, queryParams)
    ).then((res) => res.body);
  }

  public async uploadMany(
    files: (string | Blob)[],
    queryParams: IFileStorageQueryParams
  ): Promise<FileDescriptor[]> {
    return firstValueFrom(
      await this.httpService.uploadMany(files, queryParams)
    ).then((res) => res.body);
  }

  public async delete(
    id: string,
    queryParams: IFileStorageQueryParams
  ): Promise<void> {
    return firstValueFrom(this.httpService.delete(id, queryParams)).then();
  }

  public async deleteMany(
    files: string[],
    queryParams: IFileStorageQueryParams
  ): Promise<FileDescriptor[]> {
    return firstValueFrom(this.httpService.deleteMany(files, queryParams)).then(
      (res) => res.body
    );
  }
}
